import React, {useEffect, useRef, useState} from 'react';
import AuthService from "../../services/auth.service";
import {useParams} from "react-router-dom";
import getAuthor from "../../services/author.service";
import "./style.css";
import Books from "../Books";
import Navbar from "../Navbar";
import followService from "../../services/follow.service";
import {trackEvent} from '../../analytics/analytics';

export default function AuthorPage() {
    const [currentUser, setCurrentUser] = useState(undefined);
    const [author, setAuthor] = useState(null);
    const [loading, setLoading] = useState(true);
    const [loadError, setLoadError] = useState(false);
    const [retryVersion, setRetryVersion] = useState(0);
    const [userFollowing, setUserFollowing] = useState(false);
    const [followError, setFollowError] = useState(false);
    const [followPending, setFollowPending] = useState(false);
    const followInFlight = useRef(false);
    const {author_id} = useParams();

    useEffect(() => {
        let cancelled = false;
        setAuthor(null);
        setLoading(true);
        setLoadError(false);
        setFollowError(false);
        setUserFollowing(false);
        const load = async () => {
            try {
                let user = null;
                try { user = localStorage.getItem('token') ? await AuthService.checkAuth() : null; } catch { /* Public author pages do not require auth/storage. */ }
                if (cancelled) return;
                setCurrentUser(user || undefined);
                const data = await getAuthor(author_id);
                if (cancelled) return;
                if (data?.author && (data.author.firstname || data.author.lastname)) {
                    setAuthor(data.author);
                    setUserFollowing(data.author.user_following === true || data.author.user_following === 'true');
                    trackEvent('author_open', {outcome: 'success'});
                }
            } catch (error) {
                if (!cancelled && error?.response?.status !== 404) setLoadError(true);
            } finally {
                if (!cancelled) setLoading(false);
            }
        };
        load();
        return () => { cancelled = true; };
    }, [author_id, retryVersion]);

    const followButtonHandler = async () => {
        if (!currentUser || followInFlight.current) return;
        followInFlight.current = true;
        setFollowPending(true);
        setFollowError(false);
        try {
            const response = userFollowing ? await followService.removeFollow(author_id) : await followService.addFollow(author_id);
            if (response.status !== 200 || (!userFollowing && response.data?.message !== 'Вы подписались на автора')) throw new Error('Unconfirmed follow');
            setUserFollowing(!userFollowing);
        } catch {
            setFollowError(true);
        } finally {
            followInFlight.current = false;
            setFollowPending(false);
        }
    };
    return <div>
        <Navbar currentUser={currentUser} setCurrentUser={setCurrentUser}/>
        <main className="catalog-page author-page">
            {loading ? <p className="catalog-state" role="status">Загружаем автора…</p>
                : loadError ? <div className="catalog-state" role="alert">
                    <h1>Не удалось загрузить автора</h1>
                    <button className="btn btn-outline-secondary" onClick={() => setRetryVersion(value => value + 1)}>Попробовать ещё раз</button>
                </div> : !author ? <div className="catalog-state"><h1>Автор не найден</h1><a href="/">Открыть каталог</a></div>
                    : <>
                        <h1 className="author-name">{[author.firstname, author.middlename, author.lastname].filter(Boolean).join(' ')}</h1>
                        <section className="author-follow" aria-label="Подписка на автора">
                            {currentUser ? <>
                                <p role="status">{userFollowing ? 'Вы подписаны на автора' : 'Сохраните автора в своих подписках'}</p>
                                <button onClick={followButtonHandler} disabled={followPending} className="btn btn-outline-secondary">
                                    {userFollowing ? 'Отписаться от автора' : 'Подписаться на автора'}
                                </button>
                                {followError && <p role="alert">Не удалось изменить подписку. Попробуйте ещё раз.</p>}
                            </> : <p>Для подписки нужен аккаунт. <a href="/login">Войдите</a> или <a href="/signup">зарегистрируйтесь</a>. Книги автора можно смотреть без входа.</p>}
                        </section>
                        <Books currentUser={currentUser} author_id={author_id}/>
                    </>}
        </main>
    </div>;
}
